module.exports = __webpack_public_path__ + "fonts/comfortaa-v27-latin-700.95d5ae27.eot";